module.exports = __webpack_public_path__ + "img/adhka-yx1zn.019.5101f898.png";